<template>
    <div 
        :class="['t-video-shop', viewCssClass]"
        :style="commonStyles"
    >
        <OHeader :view="view"/>
        <div class="video-shop-container">
            <OBadge
                v-if="!isShowSidebar"
                :view="view"
                configField="header"
            />

            <!-- <router-view /> -->

            <div class="video-shop-wrapper">
                <router-view />

                <div 
                    class="video-shop-sidebar"
                    v-if="isShowSidebar && sidebarComponent"
                >
                    <component
                        :is="sidebarComponent"
                        :item="currentService"
                        :item-name="currentServiceName"
                    />
                </div>
            </div>
        </div>
        <OFooter :view="view" />
    </div>
</template>

<script>
import OBadge from '../../../organisms/o-badge';
import OHeader from '../../../organisms/o-header';
import OFooter from '../../../organisms/o-footer/o-footer';

import { VIEWS } from "@/utils/constants/pages";
import { mapGetters } from 'vuex';

export default {
    name: "TVideoShop",
    components: {
        OHeader,
        OBadge,
        OFooter,
        OModalItemDetails3: () => import('../../../organisms/o-modal-item-details-3')
    },
    setup() {
        const view = VIEWS.VIDEO_SHOP;

        return {
            view
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getDenormalisedObjectById'
        ]),
        commonStyles() {
            return this.getMapConfigProp('components.TVideoShop.styles');
        },
        commonParams() {
            return this.getMapConfigProp('components.TVideoShop.params');
        },
        isShowSidebar() {
            return this.commonParams?.is_show_sidebar;
        },
        viewCssClass() {
            return this.$route.name.split('.')[1] || null;
        },
        currentServiceName() {
            return this.t(this.currentService.meta, 'name')
        },
        currentService() {
            return this.getDenormalisedObjectById(this.$route.query.objectId)
        },
        sidebarComponent() {
            return this.commonParams?.sidebar_component || 'OModalItemDetails3'
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />